import React, { useState, useEffect } from "react"
import ContactUs from "../data/ContactUs"

export default function MainNav() {
  const [contactTypes, setContactTypes] = useState(null)
  const currentPath = window.location.pathname + window.location.search

  // Detect mobile view using matchMedia
  const [mobileView, setMobileView] = useState(
    () => window.matchMedia("(max-width: 1024px)").matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)")
    const handleChange = (e) => setMobileView(e.matches)
    mediaQuery.addEventListener("change", handleChange)
    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [])

  const navigationItems = [
    {
      href: "/promotion",
      src: "/images/icon/promotion-icons.webp",
      label: "Promotions",
      alt: "Promotions Icon",
      className: "nav-item-promotions",
    },
    {
      href: "/",
      src: "/images/icon/home-icons.webp",
      label: "Home",
      alt: "Home Icon",
      className: "nav-item-home",
    },
    {
      href: "/slots/?provider=JILI",
      src: "/images/icon/slots-icons.webp",
      label: "Slots",
      alt: "Slots Icon",
      className: "nav-item-slots",
    },
    {
      href: "/live-casino",
      src: "/images/icon/live-dealer-icons.webp",
      label: "Live Dealer",
      alt: "Live Dealer Icon",
      className: "nav-item-live-dealer",
    },
    {
      href: "/sportsbook",
      src: "/images/icon/sports-icons.webp",
      label: "Sportsbook",
      alt: "Sportsbook Icon",
      className: "nav-item-sportsbook",
    },
  ]

  const secondaryItems = [
    {
      href: "/vip",
      src: "/images/icon/vip-icons.webp",
      label: "VIP",
      alt: "VIP Icon",
      className: "nav-item-vip",
    },
    {
      href: "#",
      src: "/images/icon/chat-support-icons.webp",
      label: "Chat Support",
      alt: "Chat Support Icon",
      className: "nav-item-chat-support",
    },
    {
      href: "/android",
      src: "/images/icon/download-app-icons.webp",
      label: "Download App",
      alt: "Download App Icon",
      className: "nav-item-download-app",
    },
  ]

  // Check localStorage for login status and (optionally) the username
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true"
  const username = localStorage.getItem("username")

  // Define the common mobile navigation items
  const mobileNavigation = [
    {
      href: "/slots/?provider=JILI",
      src: "/images/icon/slots-icons.webp",
      label: "Slots",
      alt: "Slots Icon",
      className: "nav-item-slots",
    },
    {
      href: "/live-casino",
      src: "/images/icon/live-dealer-icons.webp",
      label: "Live",
      alt: "Live Dealer Icon",
      className: "nav-item-live-casino",
    },
    {
      href: "/",
      src: "/images/icon/fgh-logo-clean.webp",
      label: "My FGH",
      alt: "My FGH Logo",
      className: "nav-item-fgh",
    },
    {
      href: "/promotion",
      src: "/images/icon/promotion-icons.webp",
      label: "Promo",
      alt: "Promo Icon",
      className: "nav-item-promo",
    },
  ]

  // Conditionally add either the Profile nav item or the Sports nav item based on login status:
  if (isLoggedIn && username) {
    mobileNavigation.push({
      href: "/profile",
      src: "/images/icon/profile-icons.webp",
      label: "Profile",
      alt: "Profile Icon",
      className: "nav-item-profile",
    })
  } else {
    mobileNavigation.push({
      href: "/sportsbook",
      src: "/images/icon/sports-icons.webp",
      label: "Sports",
      alt: "Sports Icon",
      className: "nav-item-sports",
    })
  }

  return (
    <>
      {!mobileView && (
        <nav className="main-navigation">
          <ul>
            {navigationItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className={`${item.className} ${
                  currentPath === item.href ? "active" : ""
                }`}
              >
                <li>
                  <img src={item.src} alt={item.alt} />
                  {item.label}
                </li>
              </a>
            ))}
          </ul>
          <div className="navigation-divider"></div>
          <ul>
            {secondaryItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className={`${item.className} ${
                  currentPath === item.href ? "active" : ""
                }`}
                onClick={(e) => {
                  if (item.className === "nav-item-chat-support") {
                    e.preventDefault()
                    setContactTypes(["telegram", "viber"])
                  }
                }}
              >
                <li>
                  <img src={item.src} alt={item.alt} />
                  {item.label}
                </li>
              </a>
            ))}
          </ul>
          <div className="navigation-divider"></div>
          <div className="social-media-links">
            <p className="title">Follow Us</p>
            <ul className="social-media-list">
              <li>
                <a
                  href="https://www.facebook.com/fungaminghubofficial"
                  target="_blank"
                >
                  <img src="/images/icon/social-media/facebook.webp" alt="" />
                </a>
              </li>
              <li>
                <a href="https://x.com/fungaminghub" target="_blank">
                  <img src="/images/icon/social-media/twitter-x.webp" alt="" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/fgh.fun/" target="_blank">
                  <img src="/images/icon/social-media/instagram.webp" alt="" />
                </a>
              </li>
              <li>
                <a href="https://telegram.me/fungaminghubph" target="_blank">
                  <img src="/images/icon/social-media/telegram.webp" alt="" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@fungaminghubph"
                  target="_blank"
                >
                  <img src="/images/icon/social-media/tiktok.webp" alt="" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@fungaminghubofficial"
                  target="_blank"
                >
                  <img src="/images/icon/social-media/youtube-1.webp" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </nav>
      )}
      {mobileView && (
        <nav className="mobile-navigation" id="mobile-nav">
          <ul className="mobile-menu">
            {mobileNavigation.map((item, index) => {
              const isActive =
                item.label !== "My FGH" &&
                window.location.pathname + window.location.search === item.href

              return (
                <a
                  key={index}
                  href={item.href}
                  className={`mobile-menu-items ${isActive ? "active" : ""}`}
                >
                  <li>
                    <div className={`mobile-menu-icons ${item.className}`}>
                      <img src={item.src} alt={item.alt} />
                    </div>
                    {item.label}
                  </li>
                </a>
              )
            })}
          </ul>
        </nav>
      )}

      <ContactUs types={contactTypes} onClose={() => setContactTypes(null)} />
    </>
  )
}
